/**
 * Signup copy and collection flags.
 *
 * collectDateOfBirth stays false until legal confirms PDPA / M02-5 consent.
 * showApprovalSla stays false until ops confirms a review time. Do not claim
 * "usually 1–2 working days" or instant access for player, coach, or parent.
 * handle_new_user grants fan only. Other roles stay pending until an admin
 * approves them (migration 20261012161000_role_request_admin_approval).
 */
export const collectDateOfBirth = false;
export const showApprovalSla = false;

export const SIGNUP_ROLE_IDS = [
  "fan",
  "player",
  "parent",
  "coach",
  "club_owner",
  "venue_owner",
  "tournament_organizer",
  "scout",
] as const;

export type SignupRole = (typeof SIGNUP_ROLE_IDS)[number];

export type SignupGroup = "play" | "coach" | "org" | "talent";

export type RoleAccess = "included" | "review";

export const SIGNUP_ROLES: { id: SignupRole; group: SignupGroup; access: RoleAccess }[] = [
  { id: "fan", group: "play", access: "included" },
  { id: "player", group: "play", access: "review" },
  { id: "parent", group: "play", access: "review" },
  { id: "coach", group: "coach", access: "review" },
  { id: "club_owner", group: "org", access: "review" },
  { id: "venue_owner", group: "org", access: "review" },
  { id: "tournament_organizer", group: "org", access: "review" },
  { id: "scout", group: "talent", access: "review" },
];

export function isSignupRole(value: string | null | undefined): value is SignupRole {
  return SIGNUP_ROLE_IDS.includes(value as SignupRole);
}

export function roleAccess(role: string): RoleAccess {
  return SIGNUP_ROLES.find((item) => item.id === role)?.access ?? "review";
}
